import { render, staticRenderFns } from "./personal-case-add.vue?vue&type=template&id=cdf4d4ae&scoped=true"
import script from "./personal-case-add.vue?vue&type=script&lang=js"
export * from "./personal-case-add.vue?vue&type=script&lang=js"
import style0 from "./personal-case-add.vue?vue&type=style&index=0&id=cdf4d4ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf4d4ae",
  null
  
)

export default component.exports